import { ApiError } from "@/api/api-axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { resetPasswordApi } from "../api/api-auth";
export function ForgotPasswordForm({
  className,
  ...props
}: React.ComponentProps<"form">) {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{
    type: "success" | "error";
    text: string;
  } | null>(null);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setIsLoading(true);

    try {
      const response = await resetPasswordApi(email);
      if (response.success) {
        setMessage({
          type: "success",
          text: "Đã gửi yêu cầu đổi mật khẩu tới email của bạn",
        });
      } else {
        setMessage({
          type: "error",
          text: response.message || "Đã xảy ra lỗi, vui lòng thử lại!",
        });
      }
    } catch (err: unknown) {
      const apiError = err as ApiError;
      setMessage({
        type: "error",
        text: apiError.data?.message || "Đã xảy ra lỗi, vui lòng thử lại!",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form
      className={cn("flex flex-col gap-6 p-6 bg-white rounded-lg border border-gray-200", className)}
      onSubmit={handleSubmit}
      {...props}
    >
      <div className="flex flex-col items-center gap-2 text-center">
        <h1 className="text-2xl font-bold">Quên mật khẩu</h1>
        <p className="text-muted-foreground text-sm text-balance">
          Nhập email để đổi mật khẩu
        </p>
      </div>

      {message && (
        <div
          className={`mb-4 p-3 rounded-md text-sm ${message.type === "success"
            ? "bg-green-50 text-green-800 border border-green-200"
            : "bg-red-50 text-red-800 border border-red-200"
            }`}
        >
          {message.text}
        </div>
      )}
      <div className="grid gap-6">
        <div className="grid gap-3">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="Nhập email của bạn"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={isLoading}
          />
        </div>

        <Button type="submit" className="w-full" disabled={isLoading}>
          {isLoading ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Đang yêu cầu...
            </>
          ) : (
            "Gửi yêu cầu"
          )}
        </Button>
        <div className="text-center text-sm">
          <span className="text-muted-foreground">Đã có tài khoản? </span>
          <Link
            to="/login"
            className="text-gray-600 hover:text-gray-700 font-medium hover:underline"
          >
            Đăng nhập ngay
          </Link>
        </div>
      </div>

      <div className="mt-4 p-3 bg-gray-50 border border-gray-200 rounded-lg">
        <p className="text-sm text-gray-600 font-medium mb-2">
          Sau khi quên mật khẩu, mật khẩu mới sẽ được gửi về email của bạn
        </p>
      </div>
    </form>
  );
}
